import axios from '../../utils/axios';
import { AxiosResponse } from 'axios';
import { API_URL } from '../../constants';
import { FulfillmentLineStatus } from './types';

export interface ReviewQueueLineItem {
  source: 'exception' | 'qc_fail';
  lineItemStatusId: number;
  shopifyLineItemGid: string;
  sku: string | null;
  reason: string;
  exceptionType: string | null;
  notes: string | null;
  fulfillmentBinCode: string | null;
}

export interface ReviewQueueOrphan {
  source: 'transfer_bin_orphan';
  associationId: number;
  warehouseBinId: number;
  reason: string;
  note: string | null;
}

export interface ReviewQueueSiblingState {
  shopifyLineItemGid: string;
  sku: string | null;
  status: FulfillmentLineStatus;
}

export interface ReviewQueueOrder {
  shopifyOrderGid: string;
  shopifyOrderName: string | null;
  lineItems: ReviewQueueLineItem[];
  orphans: ReviewQueueOrphan[];
  siblingLineStates: ReviewQueueSiblingState[];
}

type ActionResult = { ok: true } | { error: string };

export async function getReviewQueue(): Promise<ReviewQueueOrder[]> {
  const res = await axios.get(`${API_URL}/fulfillment/review-queue`);
  return (res as AxiosResponse<ReviewQueueOrder[]>).data;
}

export async function reinjectReviewLine(lineItemGid: string): Promise<ActionResult> {
  const encoded = encodeURIComponent(lineItemGid);
  const res = await axios.post(`${API_URL}/fulfillment/review-queue/lines/${encoded}/reinject`);
  return (res as AxiosResponse<ActionResult>).data;
}

export async function reassignReviewLocation(
  lineItemGid: string,
  binCode: string,
): Promise<ActionResult> {
  const encoded = encodeURIComponent(lineItemGid);
  const res = await axios.post(
    `${API_URL}/fulfillment/review-queue/lines/${encoded}/reassign-location`,
    {
      binCode,
    },
  );
  return (res as AxiosResponse<ActionResult>).data;
}

export async function markShortReviewLine(lineItemGid: string): Promise<ActionResult> {
  const encoded = encodeURIComponent(lineItemGid);
  const res = await axios.post(`${API_URL}/fulfillment/review-queue/lines/${encoded}/mark-short`);
  return (res as AxiosResponse<ActionResult>).data;
}

export async function resolveTransferOrphan(associationId: number): Promise<ActionResult> {
  const res = await axios.post(
    `${API_URL}/fulfillment/review-queue/orphans/${associationId}/resolve`,
  );
  return (res as AxiosResponse<ActionResult>).data;
}
